import React, { useContext, useEffect } from "react";
import { AuthContext } from "../../context/auth/AuthContext";
import Error from "../../components/Error";
import Loading from "../../components/Loading";
import { useDispatch, useSelector } from "react-redux";
import { getEklokDataSelector } from "../../store/data/common-data.store";
import PullToRefresh from "react-simple-pull-to-refresh";
import { Box, makeStyles } from "@material-ui/core";
import {
  getAssistanceData,
  getAssistanceDataSuccess,
} from "../../store/assistance-page.store";
import AssistanceView from "../../views/mobile-frame/assistance/AssistanceView";

const useStyles = makeStyles((theme) => ({
  container: {
    justifyContent: "center",
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
  },
}));

const AssistanceContainer = ({ eklok }) => {
  const dispatch = useDispatch();
  const classes = useStyles();

  const { token } = useContext(AuthContext);

  const { assistanceData, error, loading } = useSelector((state) => {
    return state.assistance;
  });
  const eklokData = useSelector(getEklokDataSelector);

  const onRefresh = () =>
    new Promise((resolve, reject) => {
      dispatch(
        getAssistanceData({
          token: token,
          eklok: eklok,
        }),
      );
      resolve();
    });

  useEffect(() => {
    if (!eklokData || eklokData.id !== eklok || assistanceData === null) {
      dispatch(
        getAssistanceData({
          token: token,
          eklok: eklok,
        }),
      );
    } else {
      dispatch(getAssistanceDataSuccess(assistanceData));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <PullToRefresh onRefresh={onRefresh} pullingContent={false}>
      {loading ? <Loading /> : null}
      <Box className={classes.container}>
        {error ? <Error message={{ message: error.message }} /> : null}
        {assistanceData ? (
          <AssistanceView
            assistanceData={assistanceData}
            eklokData={eklokData}
          />
        ) : null}
      </Box>
    </PullToRefresh>
  );
};

export default AssistanceContainer;
